import { defineComponent as _defineComponent } from 'vue'
import {
  getSendCaptcha,
  lockProcessLine,
  resetProcessLinePass,
  unlockProcessLine,
} from '@/apis/productionLineLock'
import { processLinePassType } from '@/apis/productionLineLock/types'
import GQRcodeAuthentication from '@/components/g-QRcode-authentication/index.vue'
import store from '@/store'
import { areaCodeOptions, isWechatQrAuthAreaCode } from '@/util/area_code'
import commonFun from '@/util/commonFun'
import { genFinalRecord } from '@/util/commonFuncs.js'
import { Message } from 'element-ui'
import md5 from 'md5'
import { computed, getCurrentInstance, ref, watch } from 'vue'

interface Props {
  visible: boolean
  status?: number
  tempStatus?: number
  verifyPassword?: boolean
  lineName: string
  codeType?: string
}

// 获取选择框的弹出容器

export default /*#__PURE__*/_defineComponent({
  __name: 'm-lock-modal',
  props: {
    visible: { type: Boolean, default: false },
    status: { default: 1 },
    tempStatus: { default: 1 },
    verifyPassword: { type: Boolean, default: false },
    lineName: { default: '' },
    codeType: { default: 'bluen_lock_production' }
  },
  emits: [
  'update:visible',
  'update:status',
  'update:tempStatus',
  'getLockPassword',
  'handleChangePasswordState',
  'update:codeType',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, status: number, tempStatus: number, verifyPassword: boolean, lineName: string, codeType: string }

const getSelectPopupContainer = (triggerNode: HTMLElement): HTMLElement => {
  return triggerNode.parentElement || document.body
}

// lbl
let thinkerx_material = sessionStorage.getItem('thinkerx_material')
// 第三方
let third_material = sessionStorage.getItem('material_cache_data')
const isUseQrCodeAuth = computed(() => {
  // 使用二维码鉴权：非第三方/老板良，且区号为中国大陆及港澳台
  return (
    !(thinkerx_material || third_material) &&
    isWechatQrAuthAreaCode(sessionStorage.getItem('area_code'))
  )
})
const that = getCurrentInstance()?.proxy as any


let visible = computed({
  get: () => props.visible,
  set: (value) => emits('update:visible', value),
})
let status = computed({
  get: () => props.status,
  set: (value) => emits('update:status', value),
})
let tempStatus = computed({
  get: () => props.tempStatus,
  set: (value) => emits('update:tempStatus', value),
})
// 倒计时数字
let countdown = ref(59) //初始设置为60s
let isShowCountDown = ref(false) // 发送验证码按钮显隐控制
// 设置的解锁密码
let unlockPassword = ref('')
// 输入的手机号
let inputPhoneNumber = ref('')
// 输入的密码
let verifyNum = ref('')
let areaCode = ref('+86')
// 输入的新密码
let newPassword = ref('')
// 输入的解锁密码
let inputUnlockPassword = ref('')
// 控制格式错误提示显隐
let isShowErrorPass = ref(false)
// 输入的验证码
let lockCaptcha = ref('')
let updateCaptcha = ref('')
// 过渡数据
// let tempStatus = props.status
function handleCancel() {
  visible.value = false
}
let limitTime = ref(Number(sessionStorage.getItem('date')) || 0)
// 发送验证码
function handleSendCaptcha(value: any, areaCodeStr?: string) {
  // 有两种区号设置 1. 用户自带 2. 自选
  areaCodeStr = areaCodeStr || store.state.userInfo.area_code || '+86'
  // 出现倒计时
  isShowCountDown.value = true
  var timer = setInterval(function () {
    if (countdown.value == 0) {
      clearInterval(timer)
      isShowCountDown.value = false
      countdown.value = 59
    } else {
      countdown.value--
    }
  }, 1000)
  // 获取当前设置的密码
  let sms_type = value === 0 ? 'bluen_device_lock' : 'bluen_reset_device_lock'
  if (props.verifyPassword) {
    sms_type = 'save_device_params'
  }
  let phone = props.verifyPassword
    ? inputPhoneNumber.value
    : store.state.userInfo.phone
  let key = {
    phone,
    sms_type: sms_type,
    area_code: areaCodeStr,
  }
  let RSkey = commonFun.calcKeyByRSA(key)
  const params = {
    phone,
    sms_type: sms_type,
    area_code: areaCodeStr,
    headers: {
      sign: RSkey,
    },
  }
  getSendCaptcha(params).then((res) => {
    if (res.status === 1) {
      Message.success(that.$t('lockModal.sendSeccess'))
    } else {
      Message.error(that.$t('lockModal.sendFail'))
    }
  })
}
// 密码输入框失去焦点验证
function inputBlur(value: any) {
  if (value?.length !== 4) {
    // 显示红字提醒，密码格式不正确
    isShowErrorPass.value = true
  } else {
    isShowErrorPass.value = false
  }
}

// === 显示二维码弹框 =================
let isAuth = ref(false) // 是否鉴权过且成功
let nonce_str = ref('')
const isShowQRCodeModal = ref(false)
function handleCancelQRCodeModal() {
  isShowQRCodeModal.value = false
}
async function handleShowQRCodeModal() {
  // 所有人都需要验证 暂且保留这个验证
  // paramsData.password = md5(unlockPassword.value||newPassword.value)
  // if (isUseQrCodeAuth.value) {
  //   paramsData.production_from = 'bluen'
  //   paramsData.sms_code = lockCaptcha.value
  // }
  // let formData = new FormData()
  // Object.keys(paramsData).map((key: string) => {
  //   formData.append(key, paramsData[key as keyof typeof paramsData])
  // })
  // const res = await lockProcessLine(formData)
  // if (res.status <= 0) {
  isAuth.value = false
  isShowQRCodeModal.value = true
  // }
}
// 鉴权成功
function authSuccessFn(val: any) {
  nonce_str.value = val
  isShowQRCodeModal.value = false
  isAuth.value = true
}
// 鉴权失败
function authFailFn(val: any) {
  isShowQRCodeModal.value = false
  isAuth.value = false
}
// 鉴权取消
function authCancelFn() {
  isShowQRCodeModal.value = false
  isAuth.value = false
}
// 保存鉴权 未设置密码场景
function onAuthSuccess(val: any) {
  nonce_str.value = val
  visible.value = false
  handleSaveLine()
}
function onAuthFail(val: any) {
  visible.value = false
}
function onAuthCancel() {
  visible.value = false
}

// ===================================

const paramsData: processLinePassType = {
  phone: store.state.userInfo.phone as string,
  sms_code: '',
  platform: 'bluen',
  area_code: store.state.userInfo.area_code as string,
  sms_type: '',
  password: '',
}
// 设置解锁密码 确认密码
function handleSetUnlockPassword() {
  paramsData.password = md5(unlockPassword.value)
  paramsData.sms_code = lockCaptcha.value
  if (isUseQrCodeAuth.value) {
    paramsData.production_from = 'bluen'
    paramsData.nonce_str = nonce_str.value
  }
  if (status.value === 0) {
    paramsData.sms_type = 'bluen_device_lock'
    let formData = new FormData()
    Object.keys(paramsData).map((key: string) => {
      formData.append(key, paramsData[key as keyof typeof paramsData])
    })
    lockProcessLine(formData).then((res) => {
      if (res.status === 1) {
        tempStatus.value = 1
        Message.success(that.$t('lockModal.updateSeccess'))
        // 关闭弹窗
        visible.value = false
        saveOperateRecord(
          that.$t('lockModal.setLockPwd'),
          unlockPassword.value,
          ''
        )
      } else {
        Message.error(res.msg)
      }
    })
  } else {
    paramsData.sms_type = 'bluen_reset_device_lock'
    let formData = new FormData()
    Object.keys(paramsData).map((key) => {
      formData.append(key, paramsData[key as keyof typeof paramsData])
    })
    resetProcessLinePass(formData).then((res) => {
      if (res.status === 1) {
        Message.success(that.$t('lockModal.editSuccess'))
        tempStatus.value = 1
        visible.value = false
        saveOperateRecord(
          that.$t('lockModal.setLockPwd'),
          unlockPassword.value,
          ''
        )
      } else {
        Message.error(res.msg)
      }
    })
  }
}
// 解锁
function handleOpenLockLine() {
  if (props.verifyPassword) {
    // 调用父组件的方法
    emits('getLockPassword', md5(inputUnlockPassword.value))
    return
  }
  const params = {
    password: md5(inputUnlockPassword.value),
    sms_type: 'bluen_device_unlock',
  }
  let formData = new FormData()
  formData.append('password', params.password)
  formData.append('sms_type', params.sms_type)
  unlockProcessLine(params).then((res) => {
    if (res.status === 1) {
      tempStatus.value = 2
      Message.success(that.$t('lockModal.lockSeccess'))
      saveOperateRecord('解锁', inputUnlockPassword.value, '')
      visible.value = false
    } else {
      if (res.data?.timestamp === -1) {
        Message.error(that.$t('lockModal.inputErrLimit'))
        clearData()
        status.value = 3
      } else {
        // 将data存入sessionStorage
        if (res.data?.timestamp) {
          sessionStorage.setItem('date', res.data.timestamp)
          limitTime.value = Number(res.data?.timestamp)
        }

        Message.error(res.msg)
      }
    }
  })
}
// 保存生产线验证
function handleSaveLine() {
  // 调用父组件的方法
  let sms_type = 'save_device_params'
  const params: processLinePassType = {
    phone: inputPhoneNumber.value,
    password: md5(inputUnlockPassword.value),
    sms_code: verifyNum.value,
    sms_type,
    area_code: areaCode.value,
  }
  if (isUseQrCodeAuth.value) {
    params.nonce_str = nonce_str.value
    params.production_from = 'bluen'
  }
  //存一下当前操作的
  store.commit('setSaveInfo', params)
  emits('getLockPassword')
}
// 重新设置锁密码
function handleRestPassword() {
  paramsData.sms_type = 'bluen_reset_device_lock'
  paramsData.password = md5(newPassword.value)
  paramsData.sms_code = updateCaptcha.value
  if (isUseQrCodeAuth.value) {
    paramsData.production_from = 'bluen'
    paramsData.nonce_str = nonce_str.value
  }
  let formData = new FormData()
  Object.keys(paramsData).map((key: string) => {
    formData.append(key, paramsData[key as keyof typeof paramsData])
  })
  resetProcessLinePass(paramsData).then((res) => {
    if (res.status === 1) {
      Message.success(that.$t('lockModal.editSuccess'))
      tempStatus.value = 1
      saveOperateRecord('修改密码', newPassword.value, '')
      visible.value = false
      sessionStorage.removeItem('date')
      limitTime.value = 0
    } else {
      Message.error(res.msg)
    }
  })
}
function handleChangePassword() {
  clearData()
  // 修改密码时 二维码type
  emits('update:codeType', 'bluen_production_pwd')
  status.value = 3
  emits('handleChangePasswordState', false)
}
function clearData() {
  // 打开页面清空数据
  unlockPassword.value = ''
  newPassword.value = ''
  inputUnlockPassword.value = ''
  lockCaptcha.value = ''
  updateCaptcha.value = ''
  inputPhoneNumber.value = ''
  verifyNum.value = ''
  areaCode.value = '+86'
  isShowErrorPass.value = false
}
// 保存操作记录
function saveOperateRecord(operate: any, password: any, oriPassword: any) {
  let recordData = {
    key: '',
    operateArr: [
      {
        key: operate,
        dataArr: [
          {
            type: 'form',
            current: {
              password,
            },
            ori: {
              password: oriPassword,
            },
            compareMsg: [
              {
                title: '',
                keys: ['password'],
              },
            ],
            formTextObj: {
              password: '密码',
            },
            formValueObj: {},
          },
        ],
      },
    ],
  }
  genFinalRecord(recordData, 'equipment_docking', '', () => {})
}
watch(
  () => visible.value,
  (newValue) => {
    isAuth.value = false
    nonce_str.value = ''
    if (!newValue) {
      if (tempStatus.value === 3) {
        tempStatus.value = 1
      }
      // status.value = tempStatus
    } else {
      // 打开页面清空数据
      clearData()
    }
  }
)
watch(
  () => props.status,
  (newValue) => {
    tempStatus.value = newValue
  }
)

return { __sfc: true,getSelectPopupContainer, props, thinkerx_material, third_material, isUseQrCodeAuth, that, emits, visible, status, tempStatus, countdown, isShowCountDown, unlockPassword, inputPhoneNumber, verifyNum, areaCode, newPassword, inputUnlockPassword, isShowErrorPass, lockCaptcha, updateCaptcha, handleCancel, limitTime, handleSendCaptcha, inputBlur, isAuth, nonce_str, isShowQRCodeModal, handleCancelQRCodeModal, handleShowQRCodeModal, authSuccessFn, authFailFn, authCancelFn, onAuthSuccess, onAuthFail, onAuthCancel, paramsData, handleSetUnlockPassword, handleOpenLockLine, handleSaveLine, handleRestPassword, handleChangePassword, clearData, saveOperateRecord, GQRcodeAuthentication, store, areaCodeOptions }
}

})